"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHasUsedCashOffer = exports.getHasNewCashOffer = exports.getHasLeasing = void 0;
var getHasLeasing = function (dealer) {
    var _a;
    return Boolean((_a = dealer === null || dealer === void 0 ? void 0 : dealer.products) === null || _a === void 0 ? void 0 : _a.hasLeasing);
};
exports.getHasLeasing = getHasLeasing;
var getHasNewCashOffer = function (dealer) {
    var _a;
    return Boolean((_a = dealer === null || dealer === void 0 ? void 0 : dealer.products) === null || _a === void 0 ? void 0 : _a.hasNewCashOffer);
};
exports.getHasNewCashOffer = getHasNewCashOffer;
var getHasUsedCashOffer = function (dealer) {
    var _a;
    return Boolean((_a = dealer === null || dealer === void 0 ? void 0 : dealer.products) === null || _a === void 0 ? void 0 : _a.hasUsedCashOffer);
};
exports.getHasUsedCashOffer = getHasUsedCashOffer;
